import { render, staticRenderFns } from "./activity_wxd.vue?vue&type=template&id=21e884d6&"
import script from "./activity_wxd.vue?vue&type=script&lang=js&"
export * from "./activity_wxd.vue?vue&type=script&lang=js&"
import style0 from "./activity_wxd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports